import UsedCard from "./UsedCard";
import kionBaoli1 from "../images/used/kion_baoli_qd30_1.jpg";
import kionBaoli2 from "../images/used/kion_baoli_qd30_2.jpg";
import d1 from "../images/used/30D1Cropped.jpg";
import d2 from "../images/used/30D2Cropped.jpg";

function UsedCards() {

    // const cardOneTitle = "6000lb Capacity Propane Forklift";

    // const cardOneText = "- One only\n\
    //     - Kion Baoli QD30\n\
    //     - 6000lb lift capacity\n\
    //     - Side shift\n\
    //     - New Forks\n\
    //     - Completely reconditioned\n\
    //     - Pneumatic Tires\n\
    //     - *New Annual Inspection\n\
    //     - Warranty Included\n\
    //     Stop by and take this for a lift today!\n\
    //     ";

    // const cardOneImages = [
    //     kionBaoli1,
    //     kionBaoli2
    // ];

    const cardsData = [
        {
            title: "6000lb Capacity Propane Forklift",
            text: "- One only\n" +
                "- Kion Baoli QD30\n" +
                "- 6000lb lift capacity\n" +
                "- Side shift\n" +
                "- New Forks\n" +
                "- Completely reconditioned\n" +
                "- Pneumatic Tires\n" +
                "- *New Annual Inspection\n" +
                "- Warranty Included\n" +
                "Stop by and take this for a lift today!",
            images: [kionBaoli1, kionBaoli2],
        },
        {
            title: "6000lb Capacity Propane Forklift",
            text: "- One only\n" +
                "- Hyundai 30D-7E\n" +
                "- 6000lb Lift Capacity\n" +
                "- Side Shift\n" +
                "- Completely Reconditioned\n" +
                "- Fully Painted\n" +
                "- Solid Pneumatic Tires\n" +
                "- *New Annual Inspection\n" +
                "- Warranty Included\n" +
                "Stop by and take this for a lift today!",
            images: [d1, d2],
        },
    ];

    return (
        <div className="flex flex-col items-center my-5">
            <div className="grid grid-cols-1 md:grid-cols-3 my-5 gap-5">
                {/* <UsedCard images={cardOneImages} title={cardOneTitle} text={cardOneText} /> */}
                {cardsData.map((card, index) => (
                    <UsedCard key={index} images={card.images} title={card.title} text={card.text} />
                ))}
            </div>
        </div>
    );
}

export default UsedCards;